import React, { Component } from "react";
import Moment from "react-moment";
import NumberFormat from "react-number-format";
import { NavLink } from "react-router-dom";
import { Button } from "reactstrap";

class CheckoutInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: {}, // Beri nilai default agar tidak error
      listProduct: [],
      datenow: new Date(),
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const state = location?.state; // Gunakan optional chaining untuk mencegah error

    if (state) {
      console.log("Received Data:", state);
      this.setState({
        isLoading: false,
        data: state, // Simpan semua data di state
        listProduct: state.productInCart || [], // Pastikan nilai tidak undefined
      });
    } else {
      console.log("No state received");
    }
  }

  render() {
    const { isLoading, data, listProduct, datenow } = this.state;

    return (
      <>
        {!isLoading ? (
          <div className="invoice-wrapper">
            <div className="invoice-content">
              <div className="header">
                <br />
                IPB Convention Hotel
                <br />
                <br />
              </div>
              <Moment format="DD MMMM YYYY, HH:mm">{datenow}</Moment>
              <br />
              <br />
              <hr />
              {listProduct.map((value, index) => (
                <div key={index} style={{ fontSize: "14px" }}>
                  {value.Product?.name} {value.qty} x
                  <NumberFormat
                    value={value.Product?.promoPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"Rp "}
                  />
                </div>
              ))}
              <br />
              <hr />
              <br />
              Subtotal :
              <NumberFormat
                value={data.productTotalPrice || 0}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"Rp "}
              />
              <br />
              Diskon :
              <NumberFormat
                value={data.Diskon || 0}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"Rp "}
              />
              <br />
              Cash :
              <NumberFormat
                value={data.totalMoney || 0}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"Rp "}
              />
              <br />
              Change :
              <NumberFormat
                value={data.cashback || 0}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"Rp "}
              />
              <br />
              <br />
              <div>Harga Sudah Termasuk PPN</div>
              <br />
              Terima Kasih <br />
              www.blst.co.id <br />
              <br />
            </div>
            <div
              className="no-print"
              onClick={() => window.print()}
              style={{ width: "100%", textAlign: "right" }}
            >
              <span style={{ cursor: "pointer" }}>
                <i
                  className="fa fa-print"
                  style={{ marginRight: "5px" }}
                  aria-hidden="true"
                ></i>{" "}
                Cetak
              </span>
            </div>
            <br />
            <div
              className="no-print"
              style={{ width: "100%", textAlign: "right" }}
            >
              <NavLink to={`/checkout/${data.tableName}`}>
                <Button> Kembali</Button>
              </NavLink>
            </div>
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h1>Generating Invoice...</h1>
          </div>
        )}
      </>
    );
  }
}

export default CheckoutInvoice;
